<template>
  <div class="sidebar">
    <div class="sidebar__container">
      <h3 class="title">Languages</h3>
      <div class="language-list" v-if="currentDocument !== undefined">
        <div class="language-child" v-for="(item, key) in currentAppLanguages" :key="key">
          <a :class="{active: item === langCode}" :href="$router.resolve({path: `/app/${app}/${category}/${item}`}).href">
            <div class="content">
              <div class="text">
                {{ getLanguageName(item) }}
              </div>
              <v-btn class="ma-2" text icon color="grey lighten-2" v-on:click.stop.prevent="openDeleteLanuguage(item)">
                <v-icon>delete</v-icon>
              </v-btn>
            </div>
          </a>
        </div>

        <!--<v-list>
        <v-list-item v-for="item in currentAppLanguages"
                     :key="item"
                     @click="">

          <v-list-item-content>
            <v-list-item-title v-text="getLanguageName(item)"></v-list-item-title>

          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon>
              <v-icon color="grey lighten-1">delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>-->

        <div class="language-child">
          <button @click="addNewLanguage()" name="addNewLanguage" id="addNewLanguage" class="add_btn"><i class="material-icons">add_circle</i><span class="title">Add Language</span></button>
        </div>
      </div>
      <TheAddNewModal modalId="addNewLanguage_sidebar"
                      :modalType="category"
                      :modalTitle="'Add New Language for '+category"
                      modalName="Language"
                      modalData="language"
                      :showModal="showAddModal"
                      :documentLanguages="currentAppLanguages"
                      @close="closeModal()" />
    </div>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Delete language?</v-card-title>
        <v-card-text>Do you really want to delete the {{ getLanguageName(this.selectedItem) }} language from the {{this.category}} document list?</v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="green darken-1" text @click="dialog = false">Cancel</v-btn>
          <v-btn color="green darken-1" text @click="deleteLanuguage()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { appMutations, appActions } from '@/constants/'
import ApiService from '@/services/ApiService'
import TheAddNewModal from '@/components/TheAddNewModal'

const { mapState } = createNamespacedHelpers('applicationState')

export default {
  name: 'thesidebar',
  components: {
    TheAddNewModal
  },
  props: {
  },
  data: function () {
    return {
      app: this.$route.params.app,
      langCode: this.$route.params.langCode,
      category: this.$route.params.category,
      currentAppLanguages: [],
      currentDocument: [],
      apiService: new ApiService(),
      showAddModal: false,
      unsubscribeList: null,
      selectedItem: null,
      dialog: false
    }
  },
  mounted () {
    // UPDATE_DATA_FROM_API
    this.$store.dispatch('applicationState/' + appActions.UPDATE_APP_SETTINGS_FROM_API, this.app).then((response) => {
      this.currentDocument = this.appDocumentList.filter(item => item.title === this.category)[0]
      this.currentAppLanguages = this.currentDocument.languages
    })
  },
  created () {
  },
  methods: {
    loadDocuments () {
      this.allDocuments = this.appDocumentList
      this.currentAppLanguages = this.appDocumentList.find(item => item.title === this.category).languages
      this.documentType = this.category
      if (this.unsubscribeList !== null) {
        this.unsubscribeList()
      }
    },
    getLanguageName (lang) {
      if (lang !== null) {
        return this.$i18n.messages[lang].message.languageFullName === undefined ? 'unknown' : this.$i18n.messages[lang].message.languageFullName
      }
    },
    updateCurrentDocument (value) {
      this.currentDocument = value
    },
    addNewLanguage () {
      this.showAddModal = true
      this.$emit('close', true)
      this.saveLanguages()
    },
    saveLanguages () {
      // Subscribe to the mutation in case another component modifies the state
      this.unsubscribeList = this.$store.subscribe(mutation => {
        if (mutation.type === 'applicationState/' + appMutations.SET_APP_SETTINGS_DOCUMENT_LIST) {
          this.loadDocuments()
        }
      })
    },
    openDeleteLanuguage (item) {
      this.selectedItem = item
      this.dialog = true
    },
    deleteLanuguage () {
      const item = this.selectedItem
      let doc = this.appDocumentList.find(x => x.title === this.category)
      doc.languages = doc.languages.filter(x => x !== item)

      this.unsubscribeList = this.$store.subscribe(mutation => {
        if (mutation.type === 'applicationState/' + appMutations.SET_APP_SETTINGS_DOCUMENT_LIST) {
          this.loadDocuments()
        }
      })

      this.$store.dispatch('applicationState/' + appActions.UPDATE_APP_SETTINGS_DOCUMENT_LIST,
        {
          name: this.appName,
          data: this.appDocumentList,
          document: doc
        }
      )

      this.selectedItem = null
      this.dialog = false

      if (doc.languages.length === 0) {
        this.$router.push(`/app/${this.app}`)
      } else if (this.langCode === item) {
        let t = `/app/${this.app}/${this.category}/${doc.languages[0]}`
        this.$router.push(t)
      }
    },
    closeModal () {
      this.showAddModal = false
    }
  },
  computed: {
    ...mapState({
      currentState: state => state,
      appName: state => state.appName,
      appDocumentList: state => state.appDocumentList
    })
  },
  watch: {
    deep: true,
    currentDocument: {
      handler: 'updateCurrentDocument'
    },
    '$route' (to, from) {
      this.langCode = to.params.langCode
    }
  }
}
</script>

<style lang="scss">
  @import '@/scss/main.scss';

  .sidebar{
    margin: 0 rem(20) 0 0;
    width: 30%;
    .title{
      text-align: left;
      margin: 0 auto rem(4) 0;
    }
    &__container{
      .language-list{
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        width: 100%;
        list-style: none;
        .language-child{
          font-family: $font-stack;
          font-size: rem(16);
          text-align: left;
          background-color: rgba($light, 0.4);
          margin: 0 0 rem(2) 0;

          a{
            display: block;
            text-decoration: none;
            color: $dark-light;
            padding: rem(12) rem(16);
            width: 100%;
            height: 100%;
            background-color: $light;
            border-left: 2px;
            border-left-color: $primary;
            border-left-style: solid;
            background-color: rgba($light, 0.2);
            border-left: 2px;
            border-left-color: $dark-light;
            border-left-style: solid;

            &.active{
              color: $primary;
              background-color: rgba($light, 1);
              border-left: 2px;
              border-left-color: $primary;
              border-left-style: solid;
            }
            &:hover{
              color: $primary;
              background-color: rgba($light, 1);
              border-left: 2px;
              border-left-color: $primary;
              border-left-style: solid;
            }

            .content {
              display: flex;
              flex-direction: row;
              align-items: center;
              width: 100%;

              .text {
                flex: 1 1 auto;
              }

              button{
                margin: 0 !important;
              }
            }
          }
        }
      }
    }

    .add_btn{
        display: block;
        font-family: $font-stack;
        font-size: rem(12);
        text-align: center;
        margin: 0;
        padding: rem(4) rem(8) rem(4) rem(4);
        color: $light;
        background: rgba($light, 0.8);
        cursor: pointer;
        border-radius: rem(5);
        border: 1px solid $light-dark;
        transition: all 0.25s ease-out;

        .title{
            color: $primary;
            margin-left: rem(28);
            font-size: rem(12);
        }
        .material-icons{
            position: absolute;
            color: rgba($primary, 1);
            font-size: rem(24);
        }

        &:hover {
            font-weight: $font-bold;
            color: $light;
        }
    }

    .saveLang_btn{
        display: block;
        font-family: $font-stack;
        font-size: rem(12);
        text-align: center;
        margin: 0;
        padding: rem(4) rem(8) rem(4) rem(4);
        color: $light;
        background: rgba($save, 0.8);
        cursor: pointer;
        border-radius: rem(5);
        border: 1px solid $light-dark;
        transition: all 0.25s ease-out;

        .title{
            color: $light;
            margin-left: rem(28);
            font-size: rem(12);
        }
        .material-icons{
            position: absolute;
            color: rgba($light, 1);
            font-size: rem(24);
        }

        &:hover {
            font-weight: $font-bold;
            color: $light;
        }
    }
  }

</style>
